(() => {
  const config = document.currentScript;
  const account = config?.dataset.account?.trim();
  if (!account || window.__gcMailerLiteScheduled) return;
  window.__gcMailerLiteScheduled = true;

  const source = 'https://assets.mailerlite.com/js/universal.js';
  const events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  const delay = Math.max(5000, Number(config.dataset.delay) || 25000);
  let timer;
  let idle;
  let loaded = false;

  window.ml = window.ml || function () {
    (window.ml.q = window.ml.q || []).push(arguments);
  };
  window.ml('account', account);

  function cleanup() {
    events.forEach(event => window.removeEventListener(event, onInteraction));
    window.removeEventListener('load', schedule);
    window.clearTimeout(timer);
    if (idle !== undefined && window.cancelIdleCallback) window.cancelIdleCallback(idle);
  }

  function load() {
    if (loaded) return;
    loaded = true;
    cleanup();
    if (window.__gcMailerLiteLoaded || document.querySelector(`script[src="${source}"]`)) return;
    window.__gcMailerLiteLoaded = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    document.head.appendChild(script);
  }

  function loadWhenIdle() {
    if (loaded || idle !== undefined) return;
    if (window.requestIdleCallback) {
      idle = window.requestIdleCallback(load, { timeout: 2000 });
    } else {
      load();
    }
  }

  function onInteraction(event) {
    if (event.type === 'scroll') loadWhenIdle();
    else load();
  }

  function schedule() {
    if (loaded) return;
    timer = window.setTimeout(loadWhenIdle, delay);
  }

  events.forEach(event => window.addEventListener(event, onInteraction, { passive: true }));
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
